import React, { useContext, useState } from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import { Link } from 'wouter';

import Footer from '../components/footer';
import PermissionsTable from '../components/permissions_configurazione_parametri';
import GiustificativiSelected from '../components/giustificativi_selected';
import JustificationProfile from '../components/justification_profile';
import RateiTable from '../components/ratei_table';
import FestivitaTable from '../components/holidays_table';
import TimbraturaSetting from '../components/timbratura_setting';
import CompanyEmailSetting from '../components/company_email_setting';
import TeamCalendarSetting from '../components/team_calendar_setting';
import PopoverComponentCustom from '../components/popover_component';

import { AuthContext } from '../contexts/auth';


function SettingsDisclosure({
    title,
    color,
    grade,
    gradeHover,
    tableComponent: TableComponent,
    defaultOpen = false,
}) {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const [showForm, setShowForm] = useState(false);
  
    return (
        <div className="mx-0 px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-center">
                <div className="container mt-5 flex w-full justify-center overflow-hidden rounded-lg bg-white shadow">
                    <div className="rounded mb-4 w-full">
                        <Disclosure defaultOpen={defaultOpen}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button
                                        className={`flex w-full justify-between bg-${color}-${grade} px-4 py-4 text-left text-sm font-medium text-gray-900 hover:bg-${color}-${gradeHover}`}
                                        onClick={() => setIsOpen(!isOpen)}
                                    >
                                        <span>{title}</span>
                                        <ChevronUpIcon
                                            className={`${
                                                !open ? 'rotate-180 transform' : ''
                                            } h-5 w-5 text-white-500`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500">
                                        {isOpen && (<TableComponent showForm={showForm} setShowForm={setShowForm} />)}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    </div>
                </div>
            </div>
        </div>
    );
}

const ConfigurazioneParametri = () => {
    const { profile } = useContext(AuthContext);

    const isProfileComplete = profile.has_complete_profile;
    const levelValues = Object.values(profile?.level || {}).flat();
    const hasShiftsLevel = levelValues.includes("shifts");
    const searchParams = new URLSearchParams(window.location.search);
    const requestedTab = searchParams.get('tab');

    const disclosureData = [
        { title: 'Impostazioni Azienda', tab: 'company_settings', color: 'gray', grade: '200', gradeHover: '300', tableComponent: CompanyEmailSetting, alwaysVisible: true, },
        { title: 'Autorizzazioni e Ruoli', tab: 'permissions', color: 'gray', grade: '200', gradeHover: '300', tableComponent: PermissionsTable, requiresShifts: true, },
        { title: 'Ratei', tab: 'ratei', color: 'gray', grade: '200', gradeHover: '300', tableComponent: RateiTable, requiresShifts: true, },
        { title: 'Giustificativi', tab: 'justifications', color: 'gray', grade: '200', gradeHover: '300', tableComponent: GiustificativiSelected, requiresShifts: true, },
        { title: 'Gruppi Giustificativi', tab: 'justification_profiles', color: 'gray', grade: '200', gradeHover: '300', tableComponent: JustificationProfile, requiresShifts: true, },
        { title: 'Festività', tab: 'holidays', color: 'gray', grade: '200', gradeHover: '300', tableComponent: FestivitaTable, requiresShifts: true, },
        { title: 'Timbrature', tab: 'attendance', color: 'gray', grade: '200', gradeHover: '300', tableComponent: TimbraturaSetting, requiresShifts: true, },
        { title: 'Il mio team', tab: 'my_team', color: 'gray', grade: '200', gradeHover: '300', tableComponent: TeamCalendarSetting, requiresShifts: true, },

        // {
        //     title: 'Impostazione Lavoro Notturno',
        //     tab: 'night_work',
        //     color: 'gray',
        //     grade: '200',
        //     gradeHover: '300',
        //     tableComponent: OrarioLavoroSetting,
        //     requiresShifts: true,
        // },
    ];

    const visibleDisclosureData = disclosureData.filter(
        (item) => {
            if (item.alwaysVisible) {return true;}

            if (item.requiresShifts) {return hasShiftsLevel;}

            return true;
        });

    return (
        <div className="flex min-h-screen flex-col">
            <PopoverComponentCustom title="Configurazione Parametri" />
            {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 p-4 text-orange-600">
                        <p className="text-center text-sm font-semibold">
                            Il profilo non è completo. <br />
                            Compila i campi mancanti{' '}
                            <Link
                                href="/profilo/fatturazione"
                                className="text-indigo-600 underline hover:text-indigo-800"
                            >
                                cliccando qui
                            </Link>
                            .
                        </p>

                    </div>
                </div>
            )}
           
            <main className="mt-10 flex-grow pb-8">
                <div className="container-fluid w-full px-4 pt-2">
                    <div className="mx-0 w-full rounded-2xl bg-white p-2">
                        {visibleDisclosureData.map(
                            (data) => {
                                const shouldOpen = requestedTab === data.tab || (!requestedTab && !hasShiftsLevel && data.tab === 'company_settings');

                                return (
                                    <SettingsDisclosure
                                        key={data.tab}
                                        title={data.title}
                                        color={data.color}
                                        grade={data.grade}
                                        gradeHover={data.gradeHover}
                                        tableComponent={data.tableComponent}
                                        defaultOpen={shouldOpen}
                                    />
                                );
                            }
                        )}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ConfigurazioneParametri;
